module.exports=function(scope){ return `{
    "data": {
        "sourceFaceMap": {
            "livenessStatus": 0
        },
        "matchLevel": 10,
        "enrollmentIdentifier": "...",
        "targetFaceMap": {
            "glasses": false,
            "faceMapType": 0,
            "ageResult": 4,
            "livenessStatus": 0,
            "auditTrailVerificationCheck": true,
            "auditTrailMatchCheck": true,
            "isReplayFaceMap": true
        },
        "message": "The /match-3d-3d request was processed and the Match Level was 10",
        "tid": "..."
    },
    "meta": {
        "code": 200,
        "ok": true,
        "message": "The /match-3d-3d request was processed and the Match Level was 10"
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/standard-server/response/success/compare.json.tpl